import { api } from '../../apiClient';

// User API service functions
export const userService = {
  // Get all users
  getAllUsers: async () => {
    const response = await api.get('/user');
    return response.data;
  },

  // Get user by ID
  getUserById: async (userId) => {
    const response = await api.get(`/user/${userId}`);
    return response.data;
  },

  // Register new user
  registerUser: async (userData) => {
    const response = await api.post('/user/register', userData);
    return response.data;
  },

  // Login user
  loginUser: async (credentials) => {
    const response = await api.post('/user/login', credentials);
    return response.data;
  },

  // Request a password-reset OTP by email
  forgotPassword: async ({ email }) => {
    const response = await api.post('/user/forgot-password', { email });
    return response.data;
  },

  // Verify the OTP, exchange it for a short-lived reset token
  verifyOtp: async ({ email, otp }) => {
    const response = await api.post('/user/verify-otp', { email, otp });
    return response.data;
  },

  // Use the reset token to set a new password
  resetPassword: async ({ resetToken, newPassword }) => {
    const response = await api.post('/user/reset-password', { resetToken, newPassword });
    return response.data;
  },

  // Update user
  updateUser: async (userId, userData) => {
    const response = await api.patch(`/user/${userId}`, userData);
    return response.data;
  },

  // Delete user
  deleteUser: async (userId) => {
    const response = await api.delete(`/user/${userId}`);
    return response.data;
  },

  // Get user profile
  getUserProfile: async () => {
    const response = await api.get('/user/profile');
    return response.data;
  },

  // Get admin dashboard (if needed)
  getAdminDashboard: async () => {
    const response = await api.get('/user/admin');
    return response.data;
  },

  // Google OAuth authentication
  googleAuth: async (googleData) => {
    const response = await api.post('/user/google-auth', googleData);
    return response.data;
  },

  // Submit KYC details
  submitKYCDetails: async (userId, kycData) => {
    const response = await api.post(`/user/${userId}/kyc`, kycData);
    return response.data;
  },

  // Submit bank details
  submitBankDetails: async (userId, bankData) => {
    const response = await api.post(`/user/${userId}/bank`, bankData);
    return response.data;
  },
};

export default userService;
